import { imageExtensions } from '../../constants/file';

export const isImage = (extesion) =>
  imageExtensions.has(extesion.toLowerCase());
